module.exports = __webpack_public_path__ + "img/d725a9c.jpg";